module.exports = __webpack_public_path__ + "media/images/user_green-d08a605c61f3ee77d46ef6a393eaa1e4.svg";